import cloneDeep from 'lodash/cloneDeep';
import * as ActionName from '../action-names';
import InitialState from '../initial-state';
import HtmlHelper from '../../utils/html-helper';
import Global from '../../global';

export default function externalContentReducer(state = InitialState.getState().externalContent, action) {

  switch (action.type) {
    case ActionName.EXTERNAL_CONTENT_LOADED: {
      const newState = cloneDeep(state);
      const placeholders = { '%%ClientExternalURL%%': Global.config.clientExternalUrl };
      newState[action.data.componentKey].content = HtmlHelper.lookForPlaceholders(action.data.content, placeholders);
      return newState;
    }
    case ActionName.SHOW_EXTERNAL_CONTENT: {
      const newState = cloneDeep(state);
      const externalContentComp = newState[action.data.componentKey];
      externalContentComp.isVisible = action.data.isVisible;
      return newState;
    }
    default:
      return state;
  }
}
